var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigBRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 307,
    fill: "none",
    viewBox: "0 0 256 307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff6f67",
    strokeLinejoin: "round",
    strokeWidth: 2.65,
    d: "M171.751 304.892c-20.156 1.799-60.528-2.34-96.101-8.339-31.614-5.159-59.749-12.837-68.327-23.575-8.219-10.318-6.66-38.633-3.18-69.647 1.38-12.477 3.24-25.315 4.68-37.853L19.02 74.896c3.06-26.996 7.38-55.01 19.257-62.688C62.932-3.75 159.694-1.47 200.726 14.548 232.4 26.664 253.935 52.7 253.995 81.314c0 25.675-12.957 53.569-26.694 59.748 15.657 13.198 29.154 41.632 25.735 72.226-5.579 49.551-30.954 86.624-81.225 91.603zm-39.232-209.48c6.838.78 14.577-2.88 15.477-10.498.12-1.2-.12-2.46-.3-4.5-1.38-5.878-5.519-9.178-10.318-9.718-6.839-.78-14.277 3.72-15.117 10.978l-.3 2.82c.42 6.959 5.339 10.378 10.618 10.978zm-12.058 125.436c6.419.72 14.577-2.82 15.417-10.078.18-1.62-.06-2.88-.3-4.499-1.74-6.299-6.299-9.299-11.158-9.839-6.419-.719-14.217 3.3-15.117 10.978-.12.78.24 1.68.12 2.46.42 7.378 5.339 10.378 10.978 11.038z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBRed);
export default __webpack_public_path__ + "static/media/big-b-red.e40ec3716c08cedb9e742dcdb711b110.svg";
export { ForwardRef as ReactComponent };